"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSION_DENIED_VIEW_MESSAGE = exports.PERMISSION_DENIED_ACTION_MESSAGE = void 0;
var PERMISSION_DENIED_VIEW_MESSAGE = "You don't have permission to view this. Contact your administrator if you need access.";
exports.PERMISSION_DENIED_VIEW_MESSAGE = PERMISSION_DENIED_VIEW_MESSAGE;
var PERMISSION_DENIED_ACTION_MESSAGE = "You don't have permission to do this.";
exports.PERMISSION_DENIED_ACTION_MESSAGE = PERMISSION_DENIED_ACTION_MESSAGE;
